// Utility for managing session-related data in localStorage
import type {
  AuthTokenData,
  RefreshTokenData,
  UserValidation,
} from '../types/session.types';

// Keys for localStorage
const AUTH_TOKEN = 'auth_token';
const PRODUCTION_UNIT = 'production_unit';
const USER_ACCESS_PROFILE = 'user_access_profile';

const appLocalStorage = {
  // Retrieves auth token data from localStorage
  getTokenData: (): AuthTokenData | null => {
    const authToken = window.localStorage.getItem(AUTH_TOKEN);
    // console.log('Retrieving auth token from localStorage:', authToken);
    if (!authToken) return null;
    return JSON.parse(authToken);
  },
  // Stores auth or refresh token data in localStorage
  setTokenData: (data: AuthTokenData | RefreshTokenData): void => {
    window.localStorage.setItem(AUTH_TOKEN, JSON.stringify(data));
  },
  // Removes auth token from localStorage
  cleanTokenData: (): void => {
    window.localStorage.removeItem(AUTH_TOKEN);
  },
  // Retrieves the raw id_token string from localStorage
  getAuthToken: (): string | null => {
    const tokenData = appLocalStorage.getTokenData();
    return tokenData ? tokenData.id_token : null;
  },
  // Retrieves production unit from localStorage
  getProductionUnit: (): string | null => {
    const productionUnit = window.localStorage.getItem(PRODUCTION_UNIT);
    if (!productionUnit) return null;
    return productionUnit;
  },
  // Stores production unit in localStorage
  setProductionUnit: (data: string): void => {
    window.localStorage.setItem(PRODUCTION_UNIT, data);
  },
  // Removes production unit from localStorage
  cleanProductionUnit: (): void => {
    window.localStorage.removeItem(PRODUCTION_UNIT);
  },
  // Retrieves user access profile from localStorage
  getUserAccessProfile: (): UserValidation | null => {
    const userAccessProfile = window.localStorage.getItem(USER_ACCESS_PROFILE);
    if (!userAccessProfile) return null;
    return JSON.parse(userAccessProfile);
  },
  // Stores user access profile in localStorage
  setAccessUserProfile: (data: UserValidation): void => {
    window.localStorage.setItem(USER_ACCESS_PROFILE, JSON.stringify(data));
  },
  // Removes user access profile from localStorage
  cleanAccessUserProfile: (): void => {
    window.localStorage.removeItem(USER_ACCESS_PROFILE);
  },
  // Clears all localStorage data
  clearLocalStorage: (): void => {
    window.localStorage.clear();
  },
};

export default appLocalStorage;
